import { Container, Text } from '@chakra-ui/react';
import { useState } from 'react';

import { FilterTile } from './FilterTile';
import { AirplaneFilter } from './AirplaneFilter';

const FILTERS = {
  AIRPLANE: 'airplane',
};

const TicketsFilters = () => {
  const [activeFilter, setActiveFilter] = useState('');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [filters, setFilters] = useState({});

  return (
    <Container width={300}>
      <Container
        display='flex'
        borderRadius='100px'
        backgroundColor='rgba(249, 249, 249, 0.25)'
        boxShadow='0px 20px 25px -5px rgba(151, 151, 151, 0.1), 0px 10px 10px -5px rgba(151, 151, 151, 0.04)'
        maxW='container.xl'
        marginBottom='60px'
        justifyContent='center'
        padding={0}
      >
        <Text display='flex' justifyContent='center' marginRight={2} flexDirection='column' color='white' fontWeight={700}>
          I Travel on:{' '}
        </Text>
        <FilterTile width={900} onOpen={setActiveFilter} title='Airplane' active={activeFilter === FILTERS.AIRPLANE}>
          <AirplaneFilter
            activeFilter={activeFilter === FILTERS.AIRPLANE}
            onChange={(value) => setFilters({ [FILTERS.AIRPLANE]: value })}
          />
        </FilterTile>
      </Container>
    </Container>
  );
};

export { TicketsFilters };
